import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { fadeInRightAnimation } from "../../../../@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "../../../../@fury/animations/fade-in-up.animation";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { ApiService } from "src/app/services/api.service";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup } from "@angular/forms";
import { FilterFormModal } from "src/app/models/form-group.model";
import { ErrorText } from "src/app/enums/error-text.enum";
import { UploadeServiceAgreementComponent } from "../uploade-service-agreement/uploade-service-agreement.component";
import endpoints from "src/app/helpers/endpoints";
import { CommonService } from "src/app/services/common.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "fury-customer-service-agreement-list",
  templateUrl: "./customer-service-agreement-list.component.html",
  styleUrls: ["./customer-service-agreement-list.component.scss"],
  animations: [fadeInRightAnimation, fadeInUpAnimation],
})
export class CustomerServiceAgreementListComponent
  implements OnInit, OnDestroy
{
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  @Input()
  columns: any[] = [
    // {name: "Agent", property: "agent", visible: true},
    {
      name: "Agreement Number",
      property: "serviceAgreementNumber",
      visible: true,
    },
    { name: "Agreement Status", property: "agreementStatus", visible: true },
    { name: "User", property: "user", visible: true },
    { name: "Plan Type", property: "planType", visible: true },
    { name: "Property Type", property: "propertyType", visible: true },
    { name: "Property Size", property: "propertySize", visible: true },
    { name: "Coverage Term", property: "coverageTerm", visible: true },
    { name: "Agreement Price", property: "agreementPrice", visible: true },
    { name: "Net Received", property: "netReceived", visible: true },
    { name: "Balance", property: "balance", visible: true },
    { name: "Created On", property: "createdOn", visible: true },
    { name: "Waiting Period", property: "waitingPeriod", visible: true },
    {
      name: "Agreement Effective Date",
      property: "agreementEffectiveDate",
      visible: true,
    },
    { name: "Copayment Fee", property: "copaymentFee", visible: true },
    { name: "Street Address", property: "streetAddress", visible: true },
    { name: "City", property: "city", visible: true },
    { name: "State", property: "state", visible: true },
    { name: "Zip", property: "zip", visible: true },
    { name: "Mobile Number", property: "mobileNumber", visible: true },
    { name: "Email Address", property: "emailAddress", visible: true },
    { name: "Hard Copy", property: "hardCopy", visible: true },
    { name: "Mailing Tracking", property: "mailingTracking", visible: true },
    { name: "Cancellation Date", property: "cancellationDate", visible: true },
    {
      name: "Reason For Cancellation",
      property: "reasonForCancellation",
      visible: true,
    },
    { name: "Payments", property: "payments", visible: true },
    { name: "Surcharge", property: "surcharge", visible: true },
    { name: "Lead Source", property: "leadSource", visible: true },
    { name: "Actions", property: "actions", visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  searchBy: string = "agreementNumber";
  searchType: string = "contains";
  isShowFilter: boolean = false;
  ngUnSubscribe = new Subject<void>();

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });
  kpiData: any = {};

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService
  ) {
    this.filterValue = "Customer Service Agreeent";
    this.router.onSameUrlNavigation = "reload";
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((res: any) => {
        this.pageIndex = res.page ? res.page - 1 : 0;
        this.searchedKeyword = res.keywords ? res.keywords : "";
        this.pageSize = res.size ? (res.size === "all" ? 9999 : res.size) : 30;
        this.searchBy = res.searchBy ? res.searchBy : "agreementNumber";
        this.searchType = res.searchType ? res.searchType : "contains";
        this.filterForm.patchValue({
          searchBy: this.searchBy,
          searchType: this.searchType,
        });
        this.getServiceAgreementList();
      });
    this.getKpiData();
  }

  ngAfterViewInit(): void {}
  onFilterChange(value: string) {
    this.pageIndex = 0;
    this.searchedKeyword = value.trim();
    this.router.navigateByUrl(
      `/customer-service-agreement/service-agreement-list?page=${
        this.pageIndex + 1
      }${this.searchedKeyword ? "&keywords=" + this.searchedKeyword : ""}${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/customer-service-agreement/service-agreement-list?page=${
        this.pageIndex + 1
      }${this.searchedKeyword ? "&keywords=" + this.searchedKeyword : ""}${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
  }

  getServiceAgreementList() {
    this.apiService
      .get(
        `${
          endpoints.customerServiceAgreement.gettAllServiceAgreementList
        }?page=${Number(this.pageIndex) + 1}&size=${this.pageSize}${
          this.searchedKeyword ? "&keywords=" + this.searchedKeyword : ""
        }&searchBy=${this.searchBy}&searchType=${this.searchType}`
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            if (res.body.agreements.data) {
              this.itemList = res.body.agreements.data;
              this.totalCount = res.body.agreements.total;
              this.dataSource = new MatTableDataSource(this.itemList);
              this.cdr.detectChanges();
            } else {
              this.itemList = undefined;
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.apiService.alert(err.error, ErrorType.Error);
        }
      );
  }
  uploadeServiceAgreement(agreementId: string) {
    let dialogRef = this.dialog.open(UploadeServiceAgreementComponent, {
      data: agreementId,
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((result) => {
        if (result) this.getServiceAgreementList();
      });
  }

  showFilter() {
    this.isShowFilter = !this.isShowFilter;
  }
  serchByValue: any[] = [
    { title: "Agreement Number", value: "agreementNumber" },
  ];
  filterChange() {
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(
      `/customer-service-agreement/service-agreement-list?page=${
        this.pageIndex + 1
      }${this.searchedKeyword ? "&keywords=" + this.searchedKeyword : ""}${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
    this.isShowFilter = false;
  }
  formatCurrency(priceValue) {
    if (!priceValue) return  "$0.00";
    return `$${Number(priceValue)?.toFixed(2)}`;
  }
  getWaitingPeriod(days) {
    if (!days) return "";
    if (Number(days) === 1) return `${days} day`;
    return `${days} days`;
  }
  redirectViewAgreementPage(row: any) {
    this.router.navigateByUrl(
      `/customer-service-agreement/view-service-agreement/${row.agreementNumber}`
    );
  }
  getServiceAgreementPdf(row: any) {
    this.apiService
      .get(
        `${endpoints.customerServiceAgreement.getAgreementPdf(row?.orderId, 1)}`
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body?.serviceAgreementPdf) {
            window.open(res.body?.serviceAgreementPdf, "_blank");
          } else {
            this.apiService.alert(
              "Service Agreement PDF Not Found",
              ErrorType.Error
            );
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  getKpiData() {
    this.apiService
      .get(endpoints.customerServiceAgreement.getAgreementKpiData)
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.kpiData = res.body;
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }

  ngOnDestroy(): void {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
